// extracted by mini-css-extract-plugin
export var boldBackground = "blog-simple-banner-cta-module--boldBackground--070c4";
export var consumerCta = "blog-simple-banner-cta-module--consumerCta--de3f8";
export var contentContainer = "blog-simple-banner-cta-module--contentContainer--21ea7";
export var heading = "blog-simple-banner-cta-module--heading--cc520";
export var providerCta = "blog-simple-banner-cta-module--providerCta--99d52";
export var subduedBackground = "blog-simple-banner-cta-module--subduedBackground--b5e03";
export var wrapper = "blog-simple-banner-cta-module--wrapper--52473";